export const createLogo = (name: string): string => {
  const words = name.split(' ');
  return words.length < 2
    ? words[0].substring(0, 1)
    : `${words[0].substring(0, 1)}${words[1].substring(0, 1)}`;
};
